'use client'
import * as React from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import invariant from 'tiny-invariant'
import { lazyComponent } from 'utils/lazy-component'

export const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL
invariant(
  LFS_URL,
  'NEXT_PUBLIC_LFS_URL is required within @repo/animations/download-button-animation',
)

const LazyLottieComponent = lazyComponent(() => import('lottie-react').then(m => m.default))

const url = `${LFS_URL}/web/features/banners/lottie/download-button-animation.json`

export function DownloadButtonAnimation({ className }: { className?: string }) {
  const queryClient = useQueryClient()
  React.useEffect(() => {
    LazyLottieComponent.preload()
    queryClient.prefetchQuery({
      queryKey: ['lottie', 'download-button-animation-data'],
      // oxlint-disable-next-line require-await
      queryFn: async () => fetch(url).then(res => res.json()),
    })
  }, [queryClient])

  const animationQuery = useQuery({
    queryKey: ['lottie', 'download-button-animation-data'],
    // oxlint-disable-next-line require-await
    queryFn: async () => fetch(url).then(res => res.json()),
  })

  if (!animationQuery.data) {
    return null
  }

  return (
    <React.Suspense fallback={<div className={className}>&nbsp;</div>}>
      {/* Make the animation color match the text color */}
      <style>
        {`
        .lottie_download_button_animation path[fill] {
          fill:currentColor !important;
        }
        .lottie_download_button_animation path[stroke] {
          stroke:currentColor !important;
        }
     `}
      </style>
      <LazyLottieComponent.component
        animationData={animationQuery.data}
        loop={true}
        className={className}
        rendererSettings={{ className: 'lottie_download_button_animation' }}
      />
    </React.Suspense>
  )
}
